/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import BossConfirmationModal from '@tcp/core/src/components/features/CnC/BagPage/views/BossConfirmationModal.view';
import CARTPAGE_CONSTANTS from '@tcp/core/src/components/features/CnC/CartItemTile/CartItemTile.constants';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import Image from '@tcp/core/src/components/common/atoms/Image';
import ReactToolTip from '@tcp/core/src/components/common/atoms/ReactToolTip';
import { getIconPath } from '@tcp/core/src/utils';
import PropTypes from 'prop-types';
import pushEventToAdobeAnalytics from '@tcp/core/src/adobeAnalytics/adobe.utils';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
} from '@tcp/core/src/utils/labels/labelUtilty.js';
import {
  GlobalGenericLabels,
  GLOBAL_GENERIC_LABELS,
  lblCreditCard,
  lblTnc,
} from '@tcp/core/src/utils/labels/globalGeneric.labels';
import styles from '../../styles/plccCheckout.style';
import BodyCopy from '../../../../../../../common/atoms/BodyCopy';
import Button from '../../../../../../../common/atoms/Button';
import PlccICLoginModal from '../PlccICLoginModal/PlccICLoginModal.view';
import PlccICShippingAddressModalView from '../PlccICShippingAddressModal/PlccICShippingAddressModal.view';
import { convertHtml } from '../../../../../LoyaltyBanner/util/utility';
import { cardIconMapping } from '../../../../../../account/common/molecule/CardTile/views/CardTile.utils';
import Anchor from '../../../../../../../common/atoms/Anchor';
import {
  getPrivacyLink,
  getTermsLink,
} from '../../../../../SinglePageCheckout/container/SinglePageCheckout.constants';
import PlccICPickupModalView from '../PlccICPickupModal/PlccICPickupModal.view';
import PlccCheckoutLabels, { GLOBAL_ADDEDTOBAG, PLCC_CHECKOUT_LABELS } from './PlccCheckout.labels';
import {
  GlobalAddToBagLabels,
  GLOBAL_ADD_TO_BAG_MODAL_LABELS,
} from '../../../../../../../../utils/labels/globalAddedToBag.labels';

const toolTipMinWidth = '300px';
const getAddress = (userCheckoutAddress) => {
  if (userCheckoutAddress) {
    const labelAddress = getDynamicLabelValues('dynamic.cart.lbl_plcc_ic_shipping_adress');
    const addressValue = `${userCheckoutAddress.addressLine1 || userCheckoutAddress.address1} ${
      userCheckoutAddress.city
    }, ${userCheckoutAddress?.state || userCheckoutAddress.stateCode} ${
      userCheckoutAddress.zipCode || userCheckoutAddress.postalCode
    }`;
    const finalLabel = `<span>${labelAddress?.replace(
      '#adress',
      `<span class="address-text-style "
      >${addressValue}</span>`
    )}</span>`;
    return convertHtml(finalLabel);
  }
  return null;
};

const getBOSSMessage = (bossAndPreOrder, bossAndGC, verifyAllExpiredCoupons, bossInEligible) => {
  const warningLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_ADD_TO_BAG_MODAL_LABELS,
    GlobalAddToBagLabels
  );
  const warningMessageLabels = getLabelFromCopyOrFromTranslation(GLOBAL_ADDEDTOBAG);
  let bossWarningMessage = '';
  if (bossAndPreOrder && bossAndGC) {
    bossWarningMessage = warningLabels?.lbl_preorder_giftcard_warning;
  } else if (bossAndPreOrder) {
    bossWarningMessage = warningLabels?.lbl_preorder_warning;
  } else if (bossAndGC) {
    bossWarningMessage = warningLabels?.lbl_giftcard_warning;
  } else if (bossInEligible) {
    bossWarningMessage = warningLabels.lbl_boss_ineligible_warning;
  } else if (verifyAllExpiredCoupons) {
    bossWarningMessage = warningMessageLabels.checkoutConfirmation?.lbl_checkoutmodal_couponError;
  }
  return bossWarningMessage;
};

const convertToShipToHome = (
  productItems,
  userDefaultStore,
  updateStoreItem,
  toggleMessageModal
) => {
  const {
    itemInfo: { itemBrand, imagePath, fit, size, itemId, qty, color, wasPrice },
    miscInfo: { shipmentId, isOnlineOnly, TCPProductIndStore },
    productInfo: { productPartNumber, tcpStyleType, variant, variantNo, tcpStyleQty },
  } = productItems?.[0];
  const { ECOM } = CARTPAGE_CONSTANTS;
  try {
    if (productItems.length !== 0) {
      const itemDetails = {
        c_prodPartNo: productPartNumber,
        c_brand: itemBrand,
        c_TCPColor: color?.toString(),
        c_TCPStyleType: tcpStyleType,
        c_TCPimages: imagePath || '',
        c_TCPProductIndStore: TCPProductIndStore,
        c_fit: fit || null,
        c_size: size,
        c_variant: variant,
        productId: variantNo,
        itemId,
        quantity: qty?.toString(),
        c_TCPStyleQTY: tcpStyleQty?.toString() || '',
        c_TCPWebOnlyFlagStore: isOnlineOnly,
        shipment_id: shipmentId,
        c_list_price: wasPrice,
      };
      const updPayload = {
        ...itemDetails,
        c_orderItemType: ECOM,
        c_fromStoreId: userDefaultStore?.basicInfo?.id,
      };
      updateStoreItem(updPayload, true);
      toggleMessageModal();
    }
  } catch (err) {
    return false;
  }
  return true;
};
// eslint-disable-next-line sonarjs/cognitive-complexity
const PlccCheckout = (props) => {
  const {
    className,
    orderType,
    userContactInfo,
    userName,
    isPlccIsShippingAddressModalOpenAtn,
    IsPlccICAddressModalOpen,
    handlePlccCheckout,
    userShippingAddress,
    verifyAllExpiredCoupons,
    userDefaultStore,
    updateStoreItem,
    productItems,
    bossAndPreOrder,
    bossAndGC,
    resetEDDCall,
    trackAnalyticClick,
    isPlccICPickupModalOpenAtn,
    isPlccICPickupModalOpen,
    orderDetails,
    isLoginV2FlowEnabled,
    isHasPickUpAlternatePerson,
    pageCategory,
    bossGCAndPreOrderCase,
    nonCacheBagLoading,
    defaultAddressForRemUser,
    rememberedUserFlag,
    plccLoginModalState,
    togglePlccModalStateAction,
    bossInEligible,
    updateSectionStateAtn,
    orderTrackingEnhancementEnabled,
  } = props;
  const plccCheckoutLabels = getLabelFromCopyOrFromTranslation(
    PLCC_CHECKOUT_LABELS,
    PlccCheckoutLabels
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeLoginModal = () => {
    togglePlccModalStateAction(false);
  };

  const closeShippingModal = (flag) => {
    updateSectionStateAtn({ isFormExpanded: false });
    isPlccIsShippingAddressModalOpenAtn(flag);
  };

  const closePickUpModal = (flag) => {
    isPlccICPickupModalOpenAtn(flag);
  };

  const toggleMessageModal = () => {
    setIsModalOpen((prev) => !prev);
  };
  let { address } = userContactInfo;
  if (typeof address === 'object' && !Array.isArray(address) && address !== null) {
    const addressArray = [];
    addressArray.push(address);
    address = addressArray;
  }
  const defaultAdress =
    address?.filter((data) => {
      return data.preferred === 'true';
    }) || null;
  const rememberUserAddress =
    defaultAddressForRemUser && JSON.parse(JSON.stringify(defaultAddressForRemUser));
  const userCheckoutAddress =
    (Object.keys(userShippingAddress).length !== 0 &&
      userShippingAddress?.addressLine1 &&
      userShippingAddress) ||
    (defaultAdress && defaultAdress[0]) ||
    (rememberedUserFlag && rememberUserAddress?.address) ||
    null;
  useEffect(() => {
    resetEDDCall();
  }, [userCheckoutAddress]);
  const getAltPickupPersonName = (store) => {
    const altName = store?.[0]?.shippingAddress?.c_altName;
    return altName?.substring(0, altName.indexOf(' '));
  };
  const cardIcon = getIconPath(cardIconMapping[`PLACE CARD_PJP`]);
  const getStoreName = () => {
    const parsedData = JSON.parse(JSON.stringify(orderDetails?.shipments));
    const store = parsedData?.filter((shipment) => {
      if (shipment?.shipmentId !== 'me' && shipment?.itemsCount > 0) {
        return shipment;
      }
      return null;
    });
    const labelAddress = getDynamicLabelValues('dynamic.cart.lbl_plcc_ic_store_address_boss_bopis');
    const altName = getAltPickupPersonName(store);
    return convertHtml(
      `<span>${labelAddress
        ?.replace(
          '#storeAdress',
          `<span class='store-address'
  >${store?.[0]?.shippingAddress?.c_storeName.toLowerCase()}</span>`
        )
        ?.replace(
          '#username',
          `<span class="username-text-style"
  >${store?.[0]?.shippingAddress?.firstName || userName}${
            isHasPickUpAlternatePerson && altName ? `, ${altName}` : `<span></span>`
          }</span>`
        )}</span>${
        store?.length > 1
          ? `<span> and</span><span class='store-address'
        >  ${store?.[1]?.shippingAddress?.c_storeName.toLowerCase()}</span>`
          : `<span></span>`
      }`
    );
  };
  const shippingaddressModal = () => {
    if (rememberedUserFlag) return null;
    isPlccIsShippingAddressModalOpenAtn(true);
  };
  const pickupModal = () => {
    isPlccICPickupModalOpenAtn(true);
  };

  const renderSepartor = () => {
    return (
      <div className="seperator elem-mt-XS elem-mb-XS">
        <BodyCopy
          textAlign="center"
          component="span"
          fontSize="fs14"
          className="seperator-style "
          fontFamily="secondary"
        >
          {'and'}
        </BodyCopy>
      </div>
    );
  };
  const getToolTipMsg = () => {
    return (
      <div>
        <BodyCopy fontWeight="semibold" component="div" fontSize="fs10" fontFamily="secondary">
          {plccCheckoutLabels.bagPage?.lbl_plcc_ic_toolTip_message_1}
        </BodyCopy>
        <BodyCopy
          fontWeight="semibold"
          component="div"
          fontSize="fs10"
          className="elem-mt-XS"
          fontFamily="secondary"
        >
          {plccCheckoutLabels.bagPage?.lbl_plcc_ic_toolTip_message_2}
        </BodyCopy>
      </div>
    );
  };
  const plccToolTipMessage = getToolTipMsg();

  const handleBuyNowClick = () => {
    if (!nonCacheBagLoading) {
      if (bossGCAndPreOrderCase || verifyAllExpiredCoupons) {
        toggleMessageModal();
      } else {
        handlePlccCheckout({ rememberedUserFlag, fromBagPage: true });
      }
      trackAnalyticClick({ metric94: '1', customEvents: ['event94'] });
      pushEventToAdobeAnalytics('bag_page_billing_start', 'plcc');
    }
    return null;
  };

  return (
    <section className={className}>
      <div className="plccWrapper">
        <div>
          <BodyCopy
            component="span"
            fontWeight="extrabold"
            fontSize="fs15"
            className="text-style-1 elem-ml-XXM"
            fontFamily="secondary"
          >
            {'My '}
          </BodyCopy>
          <BodyCopy
            component="span"
            fontWeight="extrabold"
            fontSize="fs15"
            className="text-style-2"
            fontFamily="secondary"
          >
            {'Place '}
          </BodyCopy>
          <BodyCopy
            component="span"
            fontWeight="extrabold"
            fontSize="fs15"
            className="text-style-3"
            fontFamily="secondary"
          >
            {'Reward$ '}
          </BodyCopy>
          <BodyCopy
            component="span"
            fontWeight="extrabold"
            fontSize="fs15"
            className="text-style-4"
            fontFamily="secondary"
          >
            {`${getLabelFromCopyOrFromTranslation(
              `${GLOBAL_GENERIC_LABELS}.${lblCreditCard}`,
              GlobalGenericLabels
            )}`}
          </BodyCopy>
          <div className="tool-tip-style">
            <ReactToolTip
              id="tool"
              direction="top-plcc"
              message={plccToolTipMessage}
              minWidth={toolTipMinWidth}
              plccTooltip
            >
              <Image alt="info" className="circle-info-image" src={getIconPath(`info-icon`)} />
            </ReactToolTip>
          </div>
        </div>
        <Button
          dataLocator="ic-buy-now"
          className="checkout elem-mb-MED elem-mt-MED"
          buttonVariation="fixed-width"
          fill="BLUE"
          // eslint-disable-next-line consistent-return
          onClick={handleBuyNowClick}
        >
          <div className={`cardTile__img_wrapper elem-mr-XS `}>
            <img alt="Place Card" src={cardIcon} />
          </div>
          <span> {plccCheckoutLabels.bagPage?.lbl_plcc_ic_buy_now}</span>
        </Button>
        {orderType === 'PURE_ECOM' && (
          <>
            <div className="address-wrapper">
              <BodyCopy
                onClick={shippingaddressModal}
                component="span"
                role="button"
                fontWeight="semibold"
                fontSize="fs14"
                fontFamily="secondary"
                dataLocator="address-modal"
              >
                {getAddress(userCheckoutAddress)}
              </BodyCopy>
            </div>
          </>
        )}

        {orderType === 'ECOM_MIX' && (
          <>
            <div className="address-wrapper">
              <BodyCopy
                onClick={shippingaddressModal}
                component="span"
                role="button"
                fontWeight="semibold"
                fontSize="fs14"
                fontFamily="secondary"
                dataLocator="address-modal"
              >
                {getAddress(userCheckoutAddress)}
              </BodyCopy>
            </div>
            {renderSepartor()}
            <BodyCopy
              onClick={pickupModal}
              component="span"
              fontWeight="semibold"
              fontSize="fs14"
              fontFamily="secondary"
            >
              {getStoreName()}
            </BodyCopy>
          </>
        )}
        {(orderType === 'PURE_BOPIS' || orderType === 'PURE_BOSS') && (
          <div className="elem-mb-XS">
            <BodyCopy
              onClick={pickupModal}
              component="span"
              fontWeight="semibold"
              fontSize="fs14"
              className="shipping-style elem-mb-XS"
              fontFamily="secondary"
              dataLocator="pickup-modal"
            >
              {getStoreName()}
            </BodyCopy>
          </div>
        )}

        <BodyCopy
          className="elem-mt-XXS"
          component="div"
          fontSize="fs8"
          fontFamily="secondary"
          textAlign="center"
        >
          {plccCheckoutLabels.bagPage?.lbl_plcc_ic_termsCondition_preText_app}
          <Anchor
            underline
            asPath={getTermsLink.activeLink}
            target="_blank"
            to={getTermsLink.activeHref}
          >
            {`${getLabelFromCopyOrFromTranslation(
              `${GLOBAL_GENERIC_LABELS}.${lblTnc}`,
              GlobalGenericLabels
            )}`}
            <span>,</span>
          </Anchor>
          {plccCheckoutLabels.review?.lbl_review_applyConditionAndText}
          <Anchor
            underline
            to={getPrivacyLink.activeHref}
            target="_blank"
            asPath={getPrivacyLink.activeLink}
          >
            {plccCheckoutLabels.review?.lbl_review_applyConditionPolicyText}
          </Anchor>
        </BodyCopy>

        <PlccICShippingAddressModalView
          openState={IsPlccICAddressModalOpen}
          onRequestClose={() => {
            if (orderTrackingEnhancementEnabled) closeShippingModal(false);
            else {
              isPlccIsShippingAddressModalOpenAtn(false);
            }
          }}
        />
        <PlccICPickupModalView
          openState={isPlccICPickupModalOpen}
          onRequestClose={() => {
            if (orderTrackingEnhancementEnabled) closePickUpModal(false);
            else {
              isPlccICPickupModalOpenAtn(false);
            }
          }}
          shipments={orderDetails?.shipments}
          isLoginV2FlowEnabled={isLoginV2FlowEnabled}
          pageCategory={pageCategory}
        />
        <BossConfirmationModal
          isOpen={isModalOpen}
          closeModal={() => toggleMessageModal()}
          message={getBOSSMessage(
            bossAndPreOrder,
            bossAndGC,
            verifyAllExpiredCoupons,
            bossInEligible
          )}
          buttonsRequired={!verifyAllExpiredCoupons}
          convertItems={() =>
            convertToShipToHome(productItems, userDefaultStore, updateStoreItem, toggleMessageModal)
          }
        />
        <PlccICLoginModal
          isLoginModalOpen={plccLoginModalState}
          closeModal={() => closeLoginModal()}
        />
      </div>
    </section>
  );
};

PlccCheckout.propTypes = {
  className: PropTypes.string,
  storeAdress: PropTypes.shape({}),
  userContactInfo: PropTypes.shape({}),
  userName: PropTypes.func,
  isPlccIsShippingAddressModalOpenAtn: PropTypes.func,
  IsPlccICAddressModalOpen: PropTypes.bool,
  orderType: PropTypes.string,
  handlePlccCheckout: PropTypes.func,
  userShippingAddress: PropTypes.shape({}),
  isPlccICPickupModalOpenAtn: PropTypes.func,
  isPlccICPickupModalOpen: PropTypes.bool,
};

PlccCheckout.defaultProps = {
  className: '',
  storeAdress: {},
  userContactInfo: {},
  userName: () => {},
  isPlccIsShippingAddressModalOpenAtn: false,
  IsPlccICAddressModalOpen: false,
  orderType: '',
  userShippingAddress: {},
  handlePlccCheckout: () => {},
  isPlccICPickupModalOpenAtn: false,
  isPlccICPickupModalOpen: false,
};

export default withStyles(PlccCheckout, styles);
export { PlccCheckout as PlccCheckoutVanilla };
